// extracted by mini-css-extract-plugin
export default {"trigger":"IUUJx","skeleton-progress":"_8e8NQ"};